import React from 'react';
import { Link } from 'react-router-dom';
import SupportersLogos from '../conference/SupportersLogos';
import useConferenceSettings from '../../hooks/useConferenceSettings';
import { getConferenceDateLabels, getConferenceContact } from '../../services/conferenceSettingsService';
import './Footer.css';

const Footer = () => {
  const { settings } = useConferenceSettings();
  const conferenceDates = settings ? getConferenceDateLabels(settings) : null;
  const contact = settings ? getConferenceContact(settings) : null;

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section footer-logo-section">
            <Link to="/" className="footer-logo-link">
              <img
                src="/images/tda-logo.png"
                alt="Tanzania Dental Association"
                className="footer-logo"
                loading="lazy"
                decoding="async"
              />
            </Link>
            <h3>{settings?.hero_title || '41st TDA Conference'}</h3>
            <p>{settings?.hero_subtitle || 'Scientific Conference & AGM 2026'}</p>
            <p>{conferenceDates?.short || '25–27 November 2026'}</p>
            <p>{conferenceDates?.location || 'Katavi Region, Tanzania'}</p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/conference">Conference</Link></li>
              <li><Link to="/register">Register</Link></li>
              <li><Link to="/wohd">WOHD</Link></li>
              <li><Link to="/abstracts">Submit Abstract</Link></li>
              <li><Link to="/packages">Packages</Link></li>
              <li><Link to="/accommodation">Accommodation</Link></li>
              <li><Link to="/member/login">Member Login</Link></li>
              <li><Link to="/leadership">Leadership</Link></li>
              <li><Link to="/speakers">Speakers</Link></li>
              <li><Link to="/tourism">Tourism</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/poster">Create Poster</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Contact</h3>
            <p>Email: {contact?.email || 'info@tdaconference2026.org'}</p>
            <p>{contact?.org_name || 'Tanzania Dental Association'}</p>
          </div>
        </div>
        <SupportersLogos variant="footer" />
        <div className="footer-bottom">
          <p>&copy; 2026 Tanzania Dental Association. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
